import { atom } from 'recoil';
import { SubmitResponse } from 'types/api';

export const showSubmitErrorState = atom<boolean>({
  key: 'ShowFormSubmitError',
  default: false,
});

export const showSubmitSuccessState = atom<boolean>({
  key: 'ShowFormSubmitSuccess',
  default: false,
});

export const formSubmissionPendingState = atom<boolean>({
  key: 'FormSubmissionPending',
  default: false,
});

export const formSubmissionErrorState = atom<string>({
  key: 'FormSubmissionError',
  default: '',
});

export const submissionResultState = atom<SubmitResponse | null>({
  key: 'FormSubmissionResult',
  default: null,
});

export const showValidationCodeErrorState = atom<boolean>({
  key: 'showValidationCodeError',
  default: false,
});
